import { memo } from 'react';
import classNames from 'classnames';
import Styles from './ContentLeft.module.scss';

const ContentLeft = ({ children, className }) => {
  return <div className={classNames(Styles.contentLeft, className)}>{children}</div>;
};

export default memo(ContentLeft);
